import { message, Select } from "antd";
import React, { useEffect, useState } from "react";
import { GetRequest, PostRequest } from "../../Api/ApiFunctions";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

const AddStaticAccount = ({ FetchNewData }) => {
  const {
    register,
    handleSubmit,
    // setValue,
    reset,
    formState: { isSubmitting },
  } = useForm();

  const [availableAccounts, setAvailableAccounts] = useState([]);
  //   const [as]
  const fetchData = async () => {
    const res = await GetRequest("all-accounts");
    if (res) {
      setAvailableAccounts(res?.accounts ?? []);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const resetAll = () => {
    FetchNewData();
    reset();
    const mdl1 = document.querySelector(
      `#new-account [data-bs-dismiss="modal"]`
    );
    if (mdl1) {
      mdl1.click();
    }
  };

  const AddNewAccount = async (data, event) => {
    event.preventDefault();
    const res = await PostRequest("mon", data);
    if (res) {
      resetAll();
    }
  };

  return (
    <div>
      <div className="modal fade" id="new-account">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>New Expense</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={resetAll}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(AddNewAccount)}>
                    <div className="" style={{ width: "100%" }}>
                      <label className="form-label">Chart of Account</label>

                      <select
                        className="form-control"
                        {...register("account_id")}
                      >
                        <option value={null}>Select an Account</option>
                        {availableAccounts?.map((dt, i) => (
                          <option key={i} value={dt.id}>
                            {dt.account_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        onClick={resetAll}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-submit"
                        disabled={isSubmitting}
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AddStaticAccount.propTypes = {
  FetchNewData: PropTypes.func, // ✅ define it as a function
  // Add other props here if needed
};

export default AddStaticAccount;
